import React from 'react'
import {useTranslation} from '@lib/intl/useTranslations'

import {ILoginInfoData} from '@store/LoginStore'
import {createLog} from '@util/logs'
import {useLoginModalStore} from '@store/LoginModalStore'
import {DarkModeStore} from '@store/DarkmodeStore'
import useAccounts from '@hook/useAccounts'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'
import useDark from '@hook/useDark'

import Text from '@component/Text/Text'
import UserAccountListItem from '@component/header/GlobalNavigation/NavigationOperations/AccountOperation/UserAccountListItem'

import IconPlusDark from '@svg/common/ic_plus_dark.svg'
import IconPlus from '@svg/common/ic_plus.svg'

interface IProps {
    className?: string
}

const UserAccountList = ({className}: IProps) => {
    const t = useTranslation()

    const {data: me} = useQueryFetchMe(undefined, false)
    const {accounts} = useAccounts()
    const showLoginModal = useLoginModalStore(state => state.showLoginModal)
    const {isRenderDark} = useDark()
    const {isCheckDark} = DarkModeStore()

    const onClickAddNewAccount = () => {
        createLog('event', 'navigation_add_account')
        showLoginModal()
    }

    return (
        <div className={`py-[5px] border-y border-gray08 dark:border-dark_gray08 ${className}`}>
            {/* title */}
            <Text className={'py-[5px] px-[30px] text-ti4 text-gray01 dark:text-dark_gray01'}>
                {t('globalNavigation.multiLogin.title')}
            </Text>

            {/* accounts */}
            <div className={'max-h-[210px] md:h-[100%] overflow-y-auto'}>
                {accounts?.map((user: ILoginInfoData) => {
                    if (user?.id != me?.id) {
                        return <UserAccountListItem key={user?.id} user={user} />
                    }
                })}
                <div
                    onClick={onClickAddNewAccount}
                    className={'px-[30px] flex items-center space-x-[10px] py-[7px] cursor-pointer'}>
                    {isCheckDark && isRenderDark ? <IconPlusDark /> : <IconPlus />}
                    <Text className={'text-body2 text-gray02 dark:text-dark_gray02 flex-1'}>
                        {t('globalNavigation.multiLogin.addAccount')}
                    </Text>
                </div>
            </div>
        </div>
    )
}
export default UserAccountList
